import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import FileUploaderSelect from "./FileUploaderSelect";
import AVTrimSlider from "./AVTrimSlider";
import AVFraming from "./AVFraming";
import PlaceholderLoading from "react-placeholder-loading";
//

const Example = () => <></>;

const AVTrimComponent = (props) => {
    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleDownload,
        titleChoose,
        titleLoadMore,
        titleSelect,
        titleDelete,
        titleReady,
        titleCancel,
        titleTrimAnotherVideo,
        titleTrim,
        titleHours,
        titleMinutes,
        titleSeconds,
        titleMilliseconds,
        titleStart,
        titleEnd,
        titleFraming,
        tip1,
        tip2,
    } = props.attributes;

    const [videoUrl, setVideoUrl] = useState("");
    const [duration, setDuration] = useState("");
    const [videoWidthExt, setVideoWidthExt] = useState("");
    const [videoHeightExt, setVideoHeightExt] = useState("");
    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [showComponent, setShowComponent] = useState("");
    const [activeTab, setActiveTab] = useState("trim");

    const handleDataChange = (
        url,
        duration,
        videoWidthExt,
        videoHeightExt,
        fileId,
        fileName
    ) => {
        setVideoUrl(url);
        setDuration(duration);
        setVideoWidthExt(videoWidthExt);
        setVideoHeightExt(videoHeightExt);
        setFileId(fileId);
        setFileName(fileName);
        setShowComponent(true);
        console.log(duration, fileId);
    };

    const [showUploader, setShowUploader] = useState(true);

    const handleDisplayUploader = (value) => {
        setShowUploader(value);
    };

    return (
        <div>
            {showComponent && (
                <>
                    {showUploader && (
                        <div className="flex justify-center my-4">
                            <button
                                className={`px-4 py-2 rounded-lg mr-2 ${
                                    activeTab === "trim"
                                        ? "bg-green-500 text-white"
                                        : "bg-green-200"
                                }`}
                                onClick={() => setActiveTab("trim")}
                            >
                                {titleTrim}
                            </button>
                            <button
                                className={`px-4 py-2 rounded-lg ${
                                    activeTab === "framing"
                                        ? "bg-green-500 text-white"
                                        : "bg-green-200"
                                }`}
                                onClick={() => setActiveTab("framing")}
                            >
                                {titleFraming}
                            </button>
                        </div>
                    )}

                    {/* Условный рендеринг контента в зависимости от активного таба */}
                    {activeTab === "trim" && (
                        <AVTrimSlider
                            setShowUploader={setShowUploader}
                            duration={duration}
                            videoWidthExt={videoWidthExt}
                            videoHeightExt={videoHeightExt}
                            fileId={fileId}
                            fileName={fileName}
                            videoUrl={videoUrl}
                            attributes={props.attributes}
                        />
                    )}

                    {activeTab === "framing" && (
                        <AVFraming
                            setShowUploader={setShowUploader}
                            duration={duration}
                            videoWidthExt={videoWidthExt}
                            videoHeightExt={videoHeightExt}
                            fileId={fileId}
                            fileName={fileName}
                            videoUrl={videoUrl}
                            attributes={props.attributes}
                        />
                    )}
                </>
            )}

            {!showComponent && (
                <>
                    <Example />
                </>
            )}

            <div style={{ marginTop: "20px" }}>
                <FileUploaderSelect
                    attributes={props.attributes}
                    componentRequestData={"AVTrimData"}
                    componentUrlUploader={"UrlUploader"}
                    setShowComponent={setShowComponent}
                    showUploader={showUploader}
                    onDataChange={handleDataChange}
                />
            </div>
        </div>
    );
};

export default AVTrimComponent;

/* if (document.getElementById("av-trim")) {
    const avTrimElement = document.getElementById("av-trim");
    const root = createRoot(avTrimElement);
    const attributes = {
        titleDragNDropSomeFilesHereOrClickToSelectFiles:
            avTrimElement.getAttribute(
                "titleDragNDropSomeFilesHereOrClickToSelectFiles"
            ),
        titleDownload: avTrimElement.getAttribute("titleDownload"),
        titleChoose: avTrimElement.getAttribute("titleChoose"),
        titleLoadMore: avTrimElement.getAttribute("titleLoadMore"),
        titleSelect: avTrimElement.getAttribute("titleSelect"),
        titleDelete: avTrimElement.getAttribute("titleDelete"),
        titleDeleteAll: avTrimElement.getAttribute("titleDeleteAll"),
        titleReady: avTrimElement.getAttribute("titleReady"),
        titleCurrentFile: avTrimElement.getAttribute("titleCurrentFile"),
        titleCancel: avTrimElement.getAttribute("titleCancel"),
        titleAdditionalOptions: avTrimElement.getAttribute(
            "titleAdditionalOptions"
        ),
        titleTrimAnotherVideo: avTrimElement.getAttribute(
            "titleTrimAnotherVideo"
        ),
        titleTrim: avTrimElement.getAttribute("titleTrim"),
        titleHours: avTrimElement.getAttribute("titleHours"),
        titleMinutes: avTrimElement.getAttribute("titleMinutes"),
        titleSeconds: avTrimElement.getAttribute("titleSeconds"),
        titleMilliseconds: avTrimElement.getAttribute("titleMilliseconds"),
        titleStart: avTrimElement.getAttribute("titleStart"),
        titleEnd: avTrimElement.getAttribute("titleEnd"),
        titleFraming: avTrimElement.getAttribute("titleFraming"),
        titleEndToStart: avTrimElement.getAttribute("titleEndToStart"),

        titleFadeInAudio: avTrimElement.getAttribute("titleFadeInAudio"),
        titleFadeInVideo: avTrimElement.getAttribute("titleFadeInVideo"),
        titleFadeOutAudio: avTrimElement.getAttribute("titleFadeOutAudio"),
        titleFadeOutVideo: avTrimElement.getAttribute("titleFadeOutVideo"),

        tip1: avTrimElement.getAttribute("tip1"),
        tip2: avTrimElement.getAttribute("tip2"),
        tip3: avTrimElement.getAttribute("tip3"),
        tip4: avTrimElement.getAttribute("tip4"),
        tip5: avTrimElement.getAttribute("tip5"),

        serverUploadUrl: avTrimElement.getAttribute("serverUploadUrl"),
        sessionId: avTrimElement.getAttribute("sessionId"),
    };
    root.render(<AVTrimComponent attributes={attributes} />);
} */

if (document.getElementById("av-trim")) {
    const avTrimElement = document.getElementById("av-trim");
    const root = createRoot(avTrimElement);
    const attributes = { ...avTrimElement.dataset };
    root.render(<AVTrimComponent attributes={attributes} />);
}
